import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Button, Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';

import ClockIcon from '../../../../assets/icons/ClockIcon';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

import DeletePlacementMenuButton from './DeletePlacementMenuButton';
import PlacementDepartmentSelector from './PlacementDepartmentSelector';
import RosterCardContainer from './RosterCardContainer';
import RosterCardMoreButton from './RosterCardMoreButton';
import rosterPropTextStyles from './rosterCardSharedStyles';
import WorkerReportButton from './WorkerReportButton';

const ReservedEmployeeRosterCard = ({
  placement,
  onManageCandidate,
  onDeleteFromOne,
  onDeleteFromAll,
  extensionGroupId,
  corporationId,
  onDepartmentUpdate,
  isJobInFuture,
  viewTimePath,
  onFavoriteClick,
}) => {
  const [isWorkerReportOpen, setIsWorkerReportOpen] = useState(false);

  return (
    <RosterCardContainer
      isFavorite={placement?.isFavorite}
      reliabilityScore={placement?.reliabilityScore}
      rawReliability={placement?.rawReliability}
      rawAls={placement?.rawAls}
      isPriorityResourcePool={placement?.isPriorityResourcePool}
      firstTimeWorkingThisCustomer={placement?.firstTimeWorkingThisCustomer}
      gpsData={placement?.gpsData}
      gpsPings={placement?.gpsPings}
      employeeName={placement?.employeeName}
      employeeId={placement?.employeeId}
      agencyId={placement?.agencyId}
      profilePictureSrc={placement?.employeeProfilePicture}
      avatarAlt={placement?.employeeName}
      isWorkerReportOpen={isWorkerReportOpen}
      onFavoriteClick={onFavoriteClick}
      employeePhoneNumber={placement?.employeePhoneNumber}
    >
      <Grid item>
        <Grid container alignItems="center" gap="12px">
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={rosterPropTextStyles}>
              {LanguageConverterV2('jobOrder.roster.timekeeping')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Button
                  variant="text"
                  color="inherit"
                  {...(isJobInFuture || !viewTimePath
                    ? { disabled: true }
                    : { component: RouterLink, to: viewTimePath })}
                  sx={{ textTransform: 'none', gap: '6px', textDecoration: 'none' }}
                >
                  <ClockIcon />
                  <Typography fontSize="14px" marginLeft="8px" fontFamily={PRIMARY_FONT[400]}>
                    {LanguageConverterV2('jobOrder.roster.timekeeping.viewTime')}
                  </Typography>
                </Button>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={rosterPropTextStyles}>
              {LanguageConverterV2('jobOrder.roster.department')}
            </Typography>
            <PlacementDepartmentSelector
              placement={placement}
              corporationId={corporationId}
              wrapperSx={{ width: '200px' }}
              onDepartmentUpdate={onDepartmentUpdate}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <WorkerReportButton
              isOpen={isWorkerReportOpen}
              onClick={() => setIsWorkerReportOpen((prev) => !prev)}
            />
            <RosterCardMoreButton onClick={onManageCandidate} />
            <DeletePlacementMenuButton
              onDeleteFromOne={onDeleteFromOne}
              onDeleteFromAll={onDeleteFromAll}
              extensionGroupId={extensionGroupId}
              isBackfill={!placement?.isOnAutoPlacementList}
            />
          </Box>
        </Grid>
      </Grid>
    </RosterCardContainer>
  );
};

ReservedEmployeeRosterCard.propTypes = {
  placement: PropTypes.shape({
    id: PropTypes.string,
    employeeId: PropTypes.string,
    employeeName: PropTypes.string,
    employeePhoneNumber: PropTypes.string,
    agencyId: PropTypes.string,
    employeeProfilePicture: PropTypes.string,
    isFavorite: PropTypes.bool,
    reliabilityScore: PropTypes.number,
    rawReliability: PropTypes.number,
    rawAls: PropTypes.number,
    isPriorityResourcePool: PropTypes.bool,
    firstTimeWorkingThisCustomer: PropTypes.bool,
    gpsData: PropTypes.shape({ onsite: PropTypes.bool }),
    gpsPings: PropTypes.arrayOf(PropTypes.shape({ onsite: PropTypes.bool })),
    status: PropTypes.string,
    isOnAutoPlacementList: PropTypes.bool,
    department: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  onManageCandidate: PropTypes.func,
  onDeleteFromOne: PropTypes.func,
  onDeleteFromAll: PropTypes.func,
  extensionGroupId: PropTypes.string,
  corporationId: PropTypes.string,
  onDepartmentUpdate: PropTypes.func,
  isJobInFuture: PropTypes.bool,
  viewTimePath: PropTypes.string,
  onFavoriteClick: PropTypes.func,
};

export default ReservedEmployeeRosterCard;
